<template>
    <v-text-field
        v-model="local_value"
        @input="HandleInput"
        @change='HandleChange'
        :type="type"
        :readonly="readonly"
        :clearable="!readonly"
        dense
        outlined
        hide-details
        :label="label || undefined"
    ></v-text-field>
</template>

<script>
export default {
    props: {
        value: {
            required: true,
        },
        label: {
            type: String,
        },
        type: {
            type: String,
            default: 'text',
        },
        readonly: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            local_value: null,
        };
    },
    mounted() {
        this.local_value = this.value;
    },
    watch: {
        local_value(val) {
            this.$emit('input', this.local_value);
        },
        value(val) {
            this.local_value = val;
        },
    },
    methods: {
        HandleInput() {
            this.$emit('input', this.local_value);
        },
        HandleChange() {
            this.$emit('change', this.local_value);
        }
    },
};
</script>

<style>
</style>